// Last-known /v1/me snapshot, keyed by Clerk user id so the shell can
// hydrate instantly on reload while a fresh fetch runs in the background.
// Holds no secrets — ApiKey carries only id/prefix/name.

import type { Me } from "./types";

const PREFIX = "condense:me:";

export function readCachedMe(clerkUserId: string): Me | null {
  try {
    const raw = localStorage.getItem(PREFIX + clerkUserId);
    return raw ? (JSON.parse(raw) as Me) : null;
  } catch {
    return null;
  }
}

export function writeCachedMe(clerkUserId: string, me: Me): void {
  try {
    localStorage.setItem(PREFIX + clerkUserId, JSON.stringify(me));
  } catch {
    // best-effort; storage disabled or full is non-fatal
  }
}

// Drop every cached /v1/me so a logout → new signup never hydrates the shell
// from a prior session's stale paint.
export function clearCachedMe(): void {
  try {
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const key = localStorage.key(i);
      if (key?.startsWith(PREFIX)) localStorage.removeItem(key);
    }
  } catch {
    // best-effort; storage disabled is non-fatal
  }
}
